import { z } from "zod";

// Parent invite CSV import row validation (075)
export const parentInviteImportRowSchema = z.object({
  first_name: z.string().min(1, "First name is required"),
  last_name: z.string().min(1, "Last name is required"),
  email: z.string().email("Invalid email address"),
  phone: z.string().optional(),
  family_code: z.string().min(1, "Family code is required"),
});

export type ParentInviteImportRow = z.infer<typeof parentInviteImportRowSchema>;

// Parent invite list query params (075)
export const parentInviteListQuerySchema = z.object({
  q: z.string().optional(),
  status: z.enum(["claimed", "unclaimed", "all"]).optional().default("all"),
  sort_by: z.enum(["created_at", "claimed_at", "last_name", "email"]).optional().default("created_at"),
  sort_dir: z.enum(["asc", "desc"]).optional().default("desc"),
  page: z.coerce.number().int().min(1).optional().default(1),
  limit: z.coerce.number().int().min(1).max(100).optional().default(20),
});

export type ParentInviteListQuery = z.infer<typeof parentInviteListQuerySchema>;
